var _line, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 129,
    viewBox: "0 0 316 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 128.5,
    x2: 316,
    y2: 128.5,
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 5C88 2.23858 90.2386 0 93 0H126C128.761 0 131 2.23858 131 5V128H88V5Z",
    fill: "#88D47B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198 52C198 49.2386 200.239 47 203 47H236C238.761 47 241 49.2386 241 52V128H198V52Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.77ca5b0a344883b8332ffaf01403e1bc.svg";
export { ForwardRef as ReactComponent };